import React from "react";
import style from "./ChargebackVolumeChart.module.scss";
import ButtonIcon from "../../../../components/ButtonIcon/ButtonIcon";
import Calender from "../../../../assets/svg/icons/common/Calender";
import CaretDown from "../../../../assets/svg/icons/common/CaretDown";
import SlidingTab from "../../../../components/SlidingTab/SlidingTab";
import Chart from "react-apexcharts";
import useCommonStore from "../../../../stores/common";

function ChargebackVolumeChart() {
  const expandDetails = useCommonStore((state) => state.expandDetails);
  const chartOptions = {
    chart: {
      type: "line",
      height: 350,
      toolbar: { show: false },
    },
    colors: ["#4C70EF", "#E03B24", "#EBB800"],
    stroke: {
      curve: "smooth",
      width: 3,
    },
    fill: {
      type: "gradient",
      gradient: {
        shade: "light",
        type: "vertical",
        shadeIntensity: 0.3,
        gradientToColors: ["#4C70EF"],
        opacityFrom: 0.4,
        opacityTo: 0,
      },
    },
    grid: {
      borderColor: "#EDEDED",
    },
    xaxis: {
      categories: ["Jan 2022", "Apr 2022", "Jul 2022", "Oct 2022", "Jan 2023"],
      labels: {
        style: {
          colors: "#888",
        },
      },
    },
    yaxis: {
      labels: {
        formatter: (value) => `$ ${value}K`,
        style: {
          colors: "#888",
        },
      },
      min: 420,
      max: 520,
    },
    legend: {
      show: true,
      position: "bottom",
      horizontalAlign: "left",
      fontSize: "12px",
      fontFamily: "Work Sans",
      fontWeight: 400,

      labels: {
        colors: "#666",
      },
    },
    dataLabels: {
      enabled: false,
    },
  };

  const series = [
    {
      name: "Sales",
      data: [470, 450, 510, 480, 500],
    },
    {
      name: "Chargebacks",
      data: [430, 435, 445, 440, 438],
    },
    {
      name: "Refunds",
      data: [425, 428, 430, 429, 431],
    },
  ];

  return (
    <div
      className={`${style.container} ${expandDetails ? style.expanded : ""}`}
    >
      <div className={style.header}>
        <h5>Chargebacks volume</h5>
        <div className={style.buttons}>
          <ButtonIcon bgColor={"#EDEDF4"}>
            <Calender />
            <span>Year</span>
            <CaretDown />
          </ButtonIcon>

          <SlidingTab options={["Amount", "Volume"]} />
        </div>
      </div>

      <div className={style.body}>
        <div>
          <Chart
            options={chartOptions}
            series={series}
            type="area"
            height={300}
          />
        </div>
      </div>
    </div>
  );
}

export default ChargebackVolumeChart;
